export default "__VITE_ASSET__DbR$wIs3__"